import React, { useCallback, useEffect, useReducer, useState } from "react"
import {
    obterParametrosDelivery,
    atualizarParametrosDelivery,
} from "../../../services/configuracaoDeliveryFornecedor"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { ParametrosDeliveryInicial } from "../models/parametrosDeliveryModel"
import { ParametrosDeliveryActionsTypes } from "./parametrosDeliveryActions"
import { ParametrosDeliveryContext } from "./ParametrosDeliveryContext"
import { parametrosDeliveryReducer } from "./parametrosDeliveryReducer"

export function ParametrosDeliveryContextProvider({ children }: { children: React.ReactNode }) {
    const [parametros, dispatch] = useReducer(parametrosDeliveryReducer, ParametrosDeliveryInicial)
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    const carregar = async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await obterParametrosDelivery(autorizacao)
            if ("retornoErro" in response) {
                setErroCarregamento(response.mensagem || "Erro ao carregar parâmetros do delivery")
            } else {
                setErroCarregamento(null)
                dispatch({
                    type: ParametrosDeliveryActionsTypes.CARREGAR,
                    payload: { ...ParametrosDeliveryInicial, ...response },
                })
            }
        } catch {
            setErroCarregamento("Erro ao carregar parâmetros do delivery")
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        carregar()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const salvar = useCallback(async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await atualizarParametrosDelivery(autorizacao, parametros)
            if ("retornoErro" in response) {
                throw new Error(response.mensagem)
            }
            dispatch({
                type: ParametrosDeliveryActionsTypes.CARREGAR,
                payload: { ...ParametrosDeliveryInicial, ...response },
            })
        } finally {
            setLoading(false)
        }
    }, [parametros, setLoading])

    return (
        <ParametrosDeliveryContext.Provider value={{ parametros, dispatch, salvar, erroCarregamento }}>
            <Loading />
            {children}
        </ParametrosDeliveryContext.Provider>
    )
}
